import {useEffect, useState, useRef, useContext} from "react";
import {Empty, Table, Tabs, Tag, message} from 'antd';
import {appContext} from "../../state";
import {getDateTimeUserFormatted, getTimeUserFormatted} from "../../utils/date";
import HeadersTabTable from "./HeadersTabTable";
import BodyTabEditor from "./BodyTabEditor";
import QueryTabTable from "./QueryTabTable";
import copyToClipboard from "../../utils/clipboard";
import {DeleteOutlined, MinusCircleOutlined} from "@ant-design/icons";
import Clone from "../../utils/clone";
import IOS from "../../icons/iOS";
import Android from "../../icons/Android";
import Curl from "../../icons/Curl";
import Postman from "../../icons/Postman";
import Mac from "../../icons/Mac";
import QuestionMark from "../../icons/QuestionMark";
function RequestsList(props) {

    const {appStateContextValue} = useContext(appContext);
    const [appState, setAppState] = appStateContextValue
    const [selectedRowIndex, setSelectedRowIndex] = useState(-1)
    const [messageApi, contextHolder] = message.useMessage();
    const [codeInClipBoard, setCodeInClipBoard] = useState(null)
    const [tableHeight, setTableHeight] = useState(0)

    window.app.isDragBarMouseDown = false
    const root = useRef();
    useEffect(() => {
        console.log('REQUESTS:',appState.requests)
        window.addEventListener('mouseup',onWindowMouseUp)
        window.addEventListener('mousemove',onWindowMouseMove)


        setTableHeight(root.current.getBoundingClientRect().height -110)

        return () => {
            console.log('UN_MOUNT')
            window.removeEventListener('mouseup',onWindowMouseUp)
            window.removeEventListener('mousemove',onWindowMouseMove)
        };

    }, []);


    const mapUserAgentToIcon = (userAgent) => {
        if (userAgent.toLowerCase().indexOf('postman') !== -1) {
            return <Postman></Postman>
        }
        if (userAgent.toLowerCase().indexOf('intel mac os x') !== -1) {
            return <Mac></Mac>
        }
        if (userAgent.toLowerCase().indexOf('iphone;') !== -1) {
            return <IOS></IOS>
        }
        if (userAgent.toLowerCase().indexOf('curl') !== -1) {
            return <Curl></Curl>
        }
        return <QuestionMark></QuestionMark>
    }

    const columns = [
        {
            title: 'Num',
            dataIndex: 'num',
            render: (_, record, index) => {
                return <span>{index + 1}</span>
            }
        },
        {
            title: 'UAgent',
            dataIndex: 'userAgent',
            render: (_, record, index) => {
                return <div className="user-agent-icon">
                    {mapUserAgentToIcon(record.request.headers['user-agent'])}
                </div>
            }
        },
        {
            title: 'Method',
            dataIndex: 'method',
            key: 'method',
           render: (_, record) => {
                let method = record.request.method
               // console.log('TAG::',method)
                let color = 'green'
               if (method.toUpperCase() === 'DELETE') {
                   color = 'red'
               }
               if (method.toUpperCase() === 'POST') {
                   color = 'blue'
               }
               if (method.toUpperCase() === 'PUT') {
                   color = 'orange'
               }
               return <Tag color={color}>{method.toUpperCase()}</Tag>
            },
        },

        {
            title: 'URL',
            dataIndex: 'url',
            key: 'url',
            render: (_, record, index) => {
                return <span>{record.request.url}</span>
            }
        },
        {
            title: 'CreatedAt',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (_, record) => {
                let createdAt = record.request.createdAt
                return <span title={getDateTimeUserFormatted(createdAt, {showSeconds:true,showMs:true})}>{getTimeUserFormatted(createdAt, {showSeconds:true,showMs:true})}</span>
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            render: (_, record) => <MinusCircleOutlined className="delete-row" onClick={props.onRowDelete.bind(this,record)}/>,
        },
    ];


    function onWindowMouseMove (e) {
        //console.log('isDragBarMouseDown', window.isDragBarMouseDown)
        if (window.app.isDragBarMouseDown) {
            let val = e.clientX
           // console.log('root',root,val)
            if (val >= 100) {
                let rectViewHome = document.querySelector('.view.home').getBoundingClientRect()
                let rect = document.querySelector('.requests-list').getBoundingClientRect()
                let details = document.querySelector('.details')
                let widthRequestDetails = val-rect.left
                let widthDetails = rectViewHome.width - widthRequestDetails
                if (widthRequestDetails <= 400) return
                if (widthDetails <= 300) return
                root.current.style.width = widthRequestDetails+'px'
                details.style.width = widthDetails+'px'
                let rest = window.innerWidth - val
                let editor = document.querySelector('.ace_editor')
                if (editor) {
                    editor.style.width = rest+'px'
                }

            }
        }
    }
    function onWindowMouseUp (e) {
        //console.log('onWindowMouseUp!')
        window.app.isDragBarMouseDown = false
    }

    function onDragBarMouseDown (e) {
        //console.log('isDragBarMouseDown!')
        window.app.isDragBarMouseDown = true
    }

    function renderSubRequestsTable (request) {
        return <Table pagination={{hideOnSinglePage:true}} dataSource={request.request.subRequests || []} columns={columns}/>
    }

    function getSubRequestsTabs (record)  {

        console.log('RECORD',record)
        let headers = Object.keys(record.request.headers).map((key) => {
            return {key:key,value:record.request.headers[key]}
        });
        let query = []
        try {
            let url = Array.from(new URL(record.request.hostname+record.request.url).searchParams)
            url.forEach( (p) => {
                query.push({key:p[0],value:p[1]})
            })
        } catch (e) {
            console.error(e)
        }



        const items = [
            {
                key: '1',
                label: 'Headers',
                children: <div>
                    <HeadersTabTable canEdit={false} headers={headers}></HeadersTabTable>
                </div>,
            },
            {
                key: '2',
                label: 'Query',
                children: <div>
                    <QueryTabTable query={query}></QueryTabTable>
                </div>,
            },
            {
                key: '3',
                label: 'Body',
                children: <div>
                    <BodyTabEditor body={record.request.body}></BodyTabEditor>
                </div>,
            },
            {
                key: '4',
                label: `All Requests (${record.request.subRequests.length})`,
                children: <div>
                    {renderSubRequestsTable(record)}
                </div>,
            },
            /*{
                key: '5',
                label: 'More',
                children: <div>Content of Tab Pane 5</div>,
            },*/
        ];
        return items
    }



    const onTabChange = (key) => {
        console.log(key);
    }

    function copyCodeToClipBoard (e) {
        let val = e.target.textContent
        console.log('val',val)
        copyToClipboard(val).then(r => {
            messageApi.open({type: 'success', content: 'Copied to clipboard'});
        })

    }

    function renderEmptyState () {
        return <Empty description="No requests received yet">
            {contextHolder}
            <code onClick={copyCodeToClipBoard} className="code">curl -i --header 'Content-Type: application/json' -X POST {process.env.REACT_APP_SERVER_MOCK_PROTOCOL+appState.mockAPI+'.'+process.env.REACT_APP_SERVER_MOCK_HOST+'/hello-world --data \'{"msg": "hello world"}\'' }</code>
        </Empty>
    }

    function onClickDeleteRequests () {
        let newAppState = Clone(appState)
        newAppState.requests = []
        setAppState(newAppState)
    }

    return (
        <div ref={root} className="requests-list">
            {<Table
                scroll={{ y: tableHeight }}
                rowClassName={ (record, index) =>  selectedRowIndex === index ? 'selected-row' : ''}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: (event) => {
                            if (event.target.closest('.delete-row')) {
                                return
                            }
                            console.log('ON_CLICK_ROW',rowIndex,record, event)
                            setSelectedRowIndex(rowIndex)
                            props.onRowSelected(record)
                        }
                    }
                }}
                expandable={{
                    expandedRowRender: (record) => {
                        return <div>
                            <Tabs defaultActiveKey="1" items={getSubRequestsTabs(record)} onChange={onTabChange}></Tabs>
                        </div>
                    },
                    rowExpandable: (record) => record.request.subRequests.length > 0,
                }}
                dataSource={appState.requests || []} columns={columns}
                locale={{
                    emptyText: renderEmptyState()
                }}
            />
            }
            <div onMouseDown={onDragBarMouseDown} className="drag-bar"></div>
            <DeleteOutlined onClick={onClickDeleteRequests} className="icon delete-requests"></DeleteOutlined>
        </div>
    );
}

export default RequestsList;
